'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgBus(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M.93 8.842c0 .556.246 1.055.632 1.402v.809a.946.946 0 101.895 0v-.316h5.052v.316a.95.95 0 00.947.947.95.95 0 00.948-.947v-.809c.385-.347.631-.846.631-1.402V2.526C11.035.316 8.775 0 5.983 0S.93.316.93 2.526v6.316zm2.21.632a.946.946 0 01-.947-.948c0-.524.423-.947.948-.947a.946.946 0 110 1.895zm5.685 0a.946.946 0 01-.948-.948c0-.524.424-.947.948-.947s.947.423.947.947a.946.946 0 01-.947.948zm.947-3.79H2.193V2.526h7.58v3.158z", id: "Bus__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Bus__svg__a" })))));
}

module.exports = SvgBus;
//# sourceMappingURL=Bus.js.map
